import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";
import logo from "../../assets/images/LandingpageImage/MinutesVault-Logo.svg";
import arrow from "../../assets/images/LandingpageImage/book-arrow.png";
import fbIcon from "../../assets/images/LandingpageImage/fb-icon.svg";
import twiter from "../../assets/images/LandingpageImage//twitter-icon.svg";
import linkedIn from "../../assets/images/LandingpageImage/linkedin-icon.svg";
import youtube from "../../assets/images/LandingpageImage/youtube-icon.svg";
import instagram from "../../assets/images/LandingpageImage/instagram-icon2.svg";
import meetingbgall from "../../assets/images/LandingpageImage/Meeting-footer.png";
import footerWhite from "../../assets/images/LandingpageImage/footer-white.png";
import arrowColor from "../../assets/images/LandingpageImage/book-arrow-color.png";

import privacypolicybg from "../../assets/images/LandingpageImage/privacy-banner-right.jpg";

import printer from "../../assets/images/printer.png";

import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Autoplay,
  Controller,
  FreeMode,
  EffectFade,
} from "swiper/modules";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "aos/dist/aos.css";
import AOS from "aos";
import { Modal, Button, Form } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useNavigate, useLocation } from "react-router-dom";
import ContactUs from "./ContactUs";
import whiteLogo from "../../assets/images/LandingpageImage/NewWiteLogo.png";
import bannerMeeting from "../../assets/images/LandingpageImage/banner-meeting.png";
import bannerArrow from "../../assets/images/LandingpageImage/book-arrow.png";
import bannerSqrFrame from "../../assets/images/LandingpageImage/banner-sqr-frame.png";
import bgImage from "../../assets/images/LandingpageImage/bg.png";
import bookArrow from "../../assets/images/LandingpageImage/book-arrow.png";
import nalco from "../../assets/images/LandingpageImage/nalco.png";
import balco from "../../assets/images/LandingpageImage/balco-logo.png";
import bankOfBaroda from "../../assets/images/LandingpageImage/Bank_of_Baroda_logo.png";
import hzl from "../../assets/images/LandingpageImage/hzl.png";
import imfa from "../../assets/images/LandingpageImage/imfa.png";
import jindal from "../../assets/images/LandingpageImage/jindal-logo.png";
import konkola from "../../assets/images/LandingpageImage/konkola.png";
import lingarajPipe from "../../assets/images/LandingpageImage/lingaraj-pipe.png";
import nmdc from "../../assets/images/LandingpageImage/nmdc.png";
import ocac from "../../assets/images/LandingpageImage/ocac-logo.png";
import facor from "../../assets/images/LandingpageImage/vedanta_facor-logo.png";
import keyfeaturesBg from "../../assets/images/LandingpageImage/explore-right-bg.png";
import tabImg1 from "../../assets/images/LandingpageImage/Source AI 1.jpg";
import tabImg2 from "../../assets/images/LandingpageImage/Source AI 2.jpg";
import tabImg3 from "../../assets/images/LandingpageImage/Source AI 3.jpg";
import tabImg4 from "../../assets/images/LandingpageImage/Source AI 4.jpg";
import tabImg5 from "../../assets/images/LandingpageImage/Source AI 5.jpg";
import tabImg6 from "../../assets/images/LandingpageImage/Source AI 6.jpg";
import listImg from "../../assets/images/LandingpageImage/icon_checkmark_purple.svg";

import vedanta from "../../assets/images/LandingpageImage/vedanta-logo.png";
import icarda from "../../assets/images/LandingpageImage/icarda.png";
import adityabirla from "../../assets/images/LandingpageImage/adityabirla.png";
import omc from "../../assets/images/LandingpageImage/omc.png";
import trl from "../../assets/images/LandingpageImage/trl.png";
//import fbIcon from "../../assets/images/LandingpageImage/fb-icon.svg";
//import footerWhite from "../../assets/images/LandingpageImage/footer-white.png";
import efficientlyOrganiseMeeting from "../../assets/images/LandingpageImage/efficiently-organise-meeting.svg";
// import meetingbgall from "../../assets/images/LandingpageImage/Meeting-footer.png";

import Greencheck from "../../assets/images/LandingpageImage/check.svg";

import ssIcon1 from "../../assets/images/LandingpageImage/ss-icon1.png";
import createMeetingSs from "../../assets/images/LandingpageImage/create-meeting-ss.png";
import zigzag1 from "../../assets/images/LandingpageImage/zigzag-1.svg";
import improvesMinutes from "../../assets/images/LandingpageImage/improves-minutes.svg";
import enhancesSeamlessCollaboration from "../../assets/images/LandingpageImage/enhances-seamless-collaboration.svg";
import efficientlyOrga from "../../assets/images/LandingpageImage/efficiently-orga.png";
import VectorSmartObject16 from "../../assets/images/LandingpageImage/VectorSmartObject16.svg";
import personKeyfeatures from "../../assets/images/LandingpageImage/person-keyfeatures.png";
import prevIconImg from "../../assets/images/LandingpageImage/prev-icon-img.png";
import nextIconImg from "../../assets/images/LandingpageImage/next-icon-img.png";
import phoneIcon from "../../assets/images/LandingpageImage/phone-icon.svg";
import mailIcon from "../../assets/images/LandingpageImage/mail-icon.svg";
import locationIcon from "../../assets/images/LandingpageImage/location-icon.svg";
import faqBg from "../../assets/images/LandingpageImage/faq-bg.png";
import bg from "../../assets/images/LandingpageImage/bg.png";
import homeShapes from "../../assets/images/LandingpageImage/home-shape.png";
import ReCAPTCHA from "react-google-recaptcha";
import constantMessages from "../../constants/constatntMessages";
//import minutesVaultVideo from "../../assets/images/LandingpageImage/minutes-vault-video.mp4";
// import "./all.min.css";
import "./animate.min.css";
import "./bootstrap.css";
import "./bootstrap.min.css";
import "./LandingPage.css";
import "./swiper-bundle.min.css";
import axios from "axios";
import { handleApiError } from "../../helpers/errorResponseHelper";
gsap.registerPlugin(ScrollTrigger);
const keyFeatures = [
  "Create Meeting",
  "RSVP Confirmation",
  "Assign & Track Agendas",
  "Write Every Minutes",
  "Real Time Notification",
  "Share Mom to Attendees",
  "Follow-On Meeting",
];
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const keyContent = [
  {
    badge: "Education",
    heading: "Unlocking Opportunities for a Brighter Future",
    desc: "Education is a powerful weapon in today’s world that enables individuals to contribute to society, pursue their dreams and create a better world.",
    stats: [
      { value: "1,625+", label: "Students Benefited" },
      { value: "58", label: "Nand Ghars Schools" },
    ],
    link: "/social-impact/csr-programs/education/",
    img: "/assets/imgs/home-social-impact/education.jpg",
  },
  // Add more content slides as needed matching the features above
];

const PrivacyPolicy = ({ currentPath }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const sendOtp = async (name, email) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/demo/demoSendOtp`,
        { name, email, type: "requestdemo" }
      );
      return response.data;
    } catch (error) {
      if (handleApiError(error)) return;
      const message =
        error.response?.data?.message || "An unexpected error occurred.";
      return { error: true, message };
    }
  };

  const jumpToReleventDiv = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      // Already on Home → scroll directly
      const releventDiv = document.getElementById(id);
      if (releventDiv) {
        releventDiv.scrollIntoView({ behavior: "smooth" });
      } else {
        alert(`Element with id '${id}' not found.`);
      }
    }
  };
const jumpToReleventDiv2 = (id) => {
  if (location.pathname !== "/") {
    // Navigate to home and pass section id
    navigate("/", { state: { scrollTo: id } });

    // Close sidebar after navigation
    toggleSidebar();
  } else {
    // Already on Home → scroll directly
    const releventDiv = document.getElementById(id);
    if (releventDiv) {
      releventDiv.scrollIntoView({ behavior: "smooth" });
    } else {
      alert(`Element with id '${id}' not found.`);
    }

    // Close sidebar after scroll
    toggleSidebar();
  }
};


  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phoneNo: "",
    email: "",
    message: "",
  });
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [otpStatus, setOtpStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpProcessloading, setOtpProcessloading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [messageError, setMessageError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [otpSendMessage, setOtpSendMessage] = useState(""); // Message for "Get OTP"
  const [otpVerifyMessage, setOtpVerifyMessage] = useState("");
  const [otpVerifiedSuccessMessage, setOtpVerifiedSuccessMessage] =
    useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(""); // Separate state for OTP
  const [otpVerified, setOtpVerified] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [srollPosition, setScrollPosition] = useState(0);
  const [isValidEmailEntered, setIsValidEmailEntered] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [otpSuccessMessage, setOTPSuccessMessageVal] = useState("");
  const [otpErrorMessage, setOTPErrorMessageVal] = useState("");
  const [otpError, setOTPError] = useState("");

  const [verifyOTPSuccessMessage, setVerifyOTPSuccessMessageVal] = useState("");
  const [verifyOTPErrorMessage, setVerifyOTPErrorMessageVal] = useState("");
  const [modalSettings, setModalSettings] = useState({ backdrop: true });

  const [showBookADemoModal, setShowBookADemoModal] = useState(false);
  //CAPTCHA
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [recaptchaError, setRecaptchaError] = useState("");
  const handleCaptchaChange = (token) => {
    setRecaptchaError("");
    setRecaptchaToken(token);
  };
  const recaptchaRef = (useRef < ReCAPTCHA) | (null > null);
  const sitekey = process.env.REACT_APP_CAPTCHA_SITE_KEY;
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
    if (position > 100) {
      document.body.classList.add("sticky-header");
    } else {
      document.body.classList.remove("sticky-header");
    }
  };
  
  const handleOpenSidebar = () => {
    // alert(1)
    setIsSidebarVisible(true);
  };
    const toggleSidebar = () => {
      // alert(2)
    setIsVisible(!isVisible);
  };

  const closeNavBar = () => {
    toggleSidebar();
  };
  useEffect(() => {
    if (location.state?.scrollTo) {
      // Delay ensures DOM is rendered
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 200);
    }
  }, [location]);

  useEffect(() => {
    if (showModal) {
      setSuccessMessage("");
    }

    if (isSidebarVisible) {
      document.body.classList.add("visible-sidebar");
    } else {
      document.body.classList.remove("visible-sidebar");
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);

      document.body.classList.remove("visible-sidebar");
    };
  }, [showModal]);
  const openBookADemoModal = () => {
    setFormData({ name: "", phoneNo: "", email: "", message: "" });
    setFormErrors({});

    setOtpStatus(false);
    setLoading(false);
    setOtpProcessloading(false);
    setOtpLoading(false);
    setErrors({});
    setNameError("");
    setPhoneError("");
    setEmailError("");
    setMessageError("");

    setOtpSendMessage("");
    setOtpVerifyMessage("");
    setOtpVerifiedSuccessMessage("");
    setOtpSent(false);
    setOtpVerified(false);
    setIsValidEmail(false);

    setIsValidEmailEntered(false);
    setIsOTPVerified(false);
    setOTPSuccessMessageVal("");
    setOTPErrorMessageVal("");

    setIsVisible(false);
    setVerifyOTPSuccessMessageVal("");
    setVerifyOTPErrorMessageVal("");
    setErrorMessage("");
    setSuccessMessage("");

    setShowBookADemoModal(true);
  };
  const closeBookADemoModal = () => {
    setShowBookADemoModal(false);
    setRecaptchaError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (isValidate()) {
      if (!isOTPVerified) {
        setErrorMessage(constantMessages.otpBeforeSubmit);
        return;
      }

      if (!recaptchaToken) {
        setRecaptchaError(constantMessages.captchaValidation);
        return;
      }

      setErrorMessage("");
      setSuccessMessage("");
      setLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/V1/demo/createDemoClient`,
          { ...formData, recaptchaToken }
        );

        if (response?.data) {
          if (response?.data?.success === true) {
            var message = response.data.message
              ? response.data.message
              : "Thank you for requesting a demo! Our team will reach out to you shortly to schedule the demo at a convenient time.";

            setSuccessMessage(message);
            setTimeout(() => {
              setSuccessMessage("");
              setShowBookADemoModal(false);
            }, 4000);

            setFormData({ name: "", phoneNo: "", email: "", message: "" });
            setFormErrors({});

            setOtpStatus(false);
            setLoading(false);
            setOtpProcessloading(false);
            setOtpLoading(false);
            setErrors({});
            setNameError("");
            setPhoneError("");
            setEmailError("");
            setMessageError("");

            setOtpSendMessage("");
            setOtpVerifyMessage("");
            setOtpVerifiedSuccessMessage("");
            setOtpSent(false);
            setOtpSent(false);
            setOtpVerified(false);
            setIsValidEmail(false);

            setIsValidEmailEntered(false);
            setIsOTPVerified(false);
            setOTPSuccessMessageVal("");
            setOTPErrorMessageVal("");

            setIsVisible(false);
            setVerifyOTPSuccessMessageVal("");
            setVerifyOTPErrorMessageVal("");
          }
          if (response.data?.success === false) {
            var message = response.data.message
              ? response.data.message
              : "Something went wrong. Please try again later.";
            setErrorMessage(message);
            setTimeout(() => {
              setErrorMessage("");
            }, 8000);
          }
        }
      } catch (error) {
        if (handleApiError(error)) return;
        setErrorMessage(error.response?.message || "Submission failed.");
        setTimeout(() => {
          setErrorMessage("");
        }, 8000);
      }
    }
  };
  const nameValidationCheck = () => {
    const newErrors = {};
    const excludeHtml = /^[0-9a-zA-Z ,&/ -]+$/;

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!excludeHtml.test(formData.name)) {
      newErrors.name = "Invalid characters";
    } else if (formData.name.trim().length < 3) {
      newErrors.name = "Minimum 3 characters required";
    } else {
      newErrors.name = "";
    }
    setNameError(newErrors.name);
  };

  const phoneValidationCheck = () => {
    const newErrors = {};
    const phonePattern = /^[0-9]{10}$/;

    if (formData.phoneNo?.trim() === "") {
      newErrors.phoneNo = "Mobile number is required";
    } else if (formData.phoneNo.length > 0 && formData.phoneNo.length < 11) {
      if (!phonePattern.test(formData.phoneNo)) {
        newErrors.phoneNo = "Please enter a valid mobile number";
      } else {
        newErrors.phoneNo = "";
      }
    } else if (formData.phoneNo.length > 10) {
      newErrors.phoneNo = "Maximum 10 digits is allowed";
    } else {
      newErrors.phoneNo = "";
    }

    setPhoneError(newErrors.phoneNo);
  };

  const emailValidationCheck = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
      setIsValidEmailEntered(false);
    } else if (!emailPattern.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
      setIsValidEmailEntered(false);
    } else {
      setIsValidEmailEntered(true);
      newErrors.email = "";
    }

    setEmailError(newErrors.email);
  };

  const modalClose = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const newValue = name === "email" ? value.toLowerCase() : value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));

    if (name === "name") {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: null,
      }));
      const newErrors = {};
      const excludeHtml = /^[0-9a-zA-Z ,&/ -]+$/;

      if (value?.trim() === "") {
        newErrors.name = "Name is required";
      } else if (!excludeHtml.test(value)) {
        newErrors.name = "Invalid characters";
      } else if (value.trim().length < 3) {
        newErrors.name = "Minimum 3 characters required";
      } else {
        newErrors.name = "";
      }

      setNameError(newErrors.name);
    }

    if (name === "phoneNo") {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        phoneNo: null,
      }));

      const newErrors = {};
      const phonePattern = /^[0-9]{10}$/;

      if (value?.trim() === "") {
        newErrors.phoneNo = "Mobile number is required";
      } else if (value.length > 0 && value.length < 11) {
        if (!phonePattern.test(value)) {
          newErrors.phoneNo = "Please enter a valid mobile number";
        } else {
          newErrors.phoneNo = "";
        }
      } else if (value.length > 10) {
        newErrors.phoneNo = "Maximum 10 digits is allowed";
      } else {
        newErrors.phoneNo = "";
      }

      setPhoneError(newErrors.phoneNo);
    }

    if (name === "email") {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        email: null,
      }));

      const newErrors = {};
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (value?.trim() === "") {
        newErrors.email = "Email is required";
        setIsValidEmailEntered(false);
      } else if (!emailPattern.test(value.toLowerCase())) {
        newErrors.email = "Please enter a valid email address.";
        setIsValidEmailEntered(false);
      } else {
        setIsValidEmailEntered(true);
        newErrors.email = "";
      }

      setEmailError(newErrors.email);
    }
  };
  const openContactUsModal = () => {
    navigate("/");
  };

  const handleKeyDown = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNo") {
      if (value.length >= 10 && ![8, 37, 39, 46].includes(e.keyCode)) {
        e.preventDefault();
      }
    }

    if (name === "otp") {
      if (value.length >= 6 && ![8, 37, 39, 46].includes(e.keyCode)) {
        e.preventDefault();
      }
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);

    if (e.target.value.toString().length == 6) {
      setOTPError("");
    }
  };

  const isValidate = () => {
    const errors = {};
    let isValid = false;

    var nameError = false;
    var mobileError = false;
    var emailError = false;

    const excludeHtml = /^[0-9a-zA-Z ,&/ -]+$/;

    if (formData.name?.trim() == "") {
      errors.name = "Name is required";
      nameError = true;
    } else if (!excludeHtml.test(formData.name)) {
      errors.name = "Invalid characters";
      nameError = true;
    } else if (formData.name.trim().length < 3) {
      errors.name = "Minimum 3 characters required";
      nameError = true;
    } else {
      errors.name = "";
      nameError = false;
    }

    const phonePattern = /^[0-9]{10}$/;

    if (formData.phoneNo?.trim() === "") {
      errors.phoneNo = "Mobile number is required";
      mobileError = true;
    } else if (formData.phoneNo.length > 0 && formData.phoneNo.length < 11) {
      if (!phonePattern.test(formData.phoneNo)) {
        errors.phoneNo = "Please enter a valid mobile number";
        mobileError = true;
      } else {
        errors.phoneNo = "";
        mobileError = false;
      }
    } else if (formData.phoneNo.length > 10) {
      errors.phoneNo = "Maximum 10 digits is allowed";
      mobileError = true;
    } else {
      errors.phoneNo = "";
      mobileError = false;
    }

    if (!formData.email.trim()) {
      errors.email = "Email is required";
      emailError = true;
    } else if (!emailPattern.test(formData.email)) {
      errors.email = "Please enter a valid email address";
      emailError = true;
    } else {
      errors.email = "";
      emailError = false;
    }

    setFormErrors(errors);

    if (nameError || mobileError || emailError) {
      isValid = false;
    } else {
      isValid = true;
    }

    return isValid;
  };

  const handleSendOtp = async () => {
    const newErrors = {};
    const excludeHtml = /^[0-9a-zA-Z ,&/ -]+$/;

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!excludeHtml.test(formData.name)) {
      newErrors.name = "Invalid characters";
    } else if (formData.name.trim().length < 3) {
      newErrors.name = "Minimum 3 characters required.";
    } else {
      newErrors.name = "";
    }

    setNameError(newErrors.name);

    if (newErrors.name != "") {
      return;
    }

    setOtpLoading(true);
    setOtpVerifyMessage("");

    setOTPSuccessMessageVal("");
    setOTPErrorMessageVal("");

    const response = await sendOtp(formData.name, formData.email);

    if (response) {
      if (response?.success === true) {
        var message = response.message
          ? response.message
          : "OTP has been sent to the entered email";
        setOtpLoading(false);
        setOtpSent(true);
        setOtp("");
        setOTPSuccessMessageVal(message);
        setTimeout(() => {
          setOTPSuccessMessageVal("");
        }, 8000);
      }
      if (response.success === false) {
        setOtpLoading(false);
        var message = response.message
          ? response.message
          : "Unable to send OTP";
        setOTPErrorMessageVal(message);
        setOtpSent(false);
        setOtp("");
        setTimeout(() => {
          setOTPErrorMessageVal("");
        }, 8000);
      }
    }
  };

  const handleVerifyOtp = async () => {
    var isSafeOtpData = false;
    var isSafeEmailData = false;

    if (!otp) {
      setOTPError("Please enter the OTP.");
      setOtpStatus(false);
      isSafeOtpData = false;
    } else if (otp.toString().length < 6) {
      setOTPError("OTP should be 6 digits.");
      setOtpStatus(false);
      isSafeOtpData = false;
    } else if (otp.toString().length == 6) {
      setOTPError("");
      isSafeOtpData = true;
    }

    const newErrors = {};

    if (formData.email?.trim() === "") {
      newErrors.email = "Email is required.";
      setIsValidEmailEntered(false);
      isSafeEmailData = false;
    } else if (!emailPattern.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
      setIsValidEmailEntered(false);
      isSafeEmailData = false;
    } else {
      setIsValidEmailEntered(true);
      newErrors.email = "";
      isSafeEmailData = true;
    }

    setEmailError(newErrors.email);

    if (isSafeOtpData == false || isSafeEmailData == false) {
      return;
    }

    setOtpProcessloading(true);
    setVerifyOTPSuccessMessageVal("");
    setVerifyOTPErrorMessageVal("");
    setVerifyOTPErrorMessageVal("");
    setOTPSuccessMessageVal("");
    setOTPErrorMessageVal("");

    const response = await verifyOtp(formData.email, otp);

    if (response) {
      if (response?.success === true) {
        var message = response.message
          ? response.message
          : "OTP verified successfully";
        setOtpProcessloading(false);
        setIsOTPVerified(true);
        setOtpSent(false);
        setOtp("");
        setOTPError("");
        setVerifyOTPSuccessMessageVal(message);
        setTimeout(() => {
          setVerifyOTPSuccessMessageVal("");
        }, 8000);
      }
      if (response.success === false) {
        setOtpProcessloading(false);
        var message = response.message
          ? response.message
          : "Unable to verify OTP";
        setVerifyOTPErrorMessageVal(message);
        setTimeout(() => {
          setVerifyOTPErrorMessageVal("");
        }, 8000);
      }
    }
  };

  const verifyOtp = async (email, otp) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/demo/verifyOtp`,
        { email, otp }
      );

      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unexpected error occurred.";
      return { success: false, message };
    }
  };
  useEffect(() => {
    document.body.classList.add("landing-page");
  }, []);
  return (
    <>
      <div
      className={`page-content landing-page ${
        isVisible ? "visible-sidebar" : ""
      }`}
    >
        <header className="fixed-header">
          <div className="container-fluid">
            <div className="header-container head">
              <div className="left-header">
                <div className="mv-logo">
                  {/* <img
                    src={logo}
                    alt="Minutes Vault Logo"
                    className="logo"
                    width="300"
                    height="62"
                    style={{ maxWidth: "100%", height: "auto" }}
                  /> */}
                  <Link to="/">
  <img
    src={logo}
    alt="Minutes Vault Logo"
    className="logo"
    width="300"
    height="62"
    style={{ maxWidth: "100%", height: "auto", cursor: "pointer" }}
  />
</Link>
                </div>
              </div>
              <div className="right-header">
                <nav className="main-menu menu ">
                  <ul>
                    <li
                      className="skiper-1 text-color"
                      onClick={() => jumpToReleventDiv("skip-to-solution")}
                    >
                      Solutions
                    </li>
                    <li
                      className="skiper-2 text-color"
                      onClick={() => jumpToReleventDiv("skip-to-features")}
                    >
                      Key Features
                    </li>
                    <li
                      className="skiper-3 text-color"
                      onClick={() =>
                        jumpToReleventDiv("skip-to-furtherquestion")
                      }
                    >
                      FAQs
                    </li>
                  </ul>

                  {/* <div className="header-btn"> */}
                  {/* <div className="book-demo-btn mt-0 line-btn">
                      <button className="book-btn" id="book-demo">
                        Book A Demo
                        <span className="arrow-spacing"> */}

                  <div className="header-btn">
                    <div className="book-demo-btn mt-0">
                      <button
                        className="book-btn"
                        id="book-demo"
                        onClick={openBookADemoModal}
                      >
                        Book A Demo
                        <span className="arrow-spacing">
                          <img src={arrow} alt="arrow" />
                        </span>
                      </button>
                    </div>
                    <div className="book-demo-btn mt-0">
                      <Link to="/login" state={{ formData, currentPath }}>
                        <button className="signin-btn2 background-wh">
                          Sign In
                          <span className="arrow-spacing">
                            <img src={arrow} alt="arrow" />
                          </span>
                        </button>
                      </Link>
                    </div>
                  </div>
                </nav>

                <div
                  className="btn14 hidden-bar-opener"
                  onClick={toggleSidebar}
                >
                  <div className="ham-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
              {/* <!-- Hamburger Menu start--> */}

      <div className="menu-overlay"></div>
      {/* <section
        className={`hidden-bar right-align ${
          isVisible ? "visible-sidebar" : ""
        }`} > */}

      <section className="hidden-bar right-align" onClick={handleOpenSidebar}>
        {/* <section className="hidden-bar right-align"> */}
        <div
          className="d-flex align-items-center justify-content-between close-btn"
          id="menu-close"
          onClick={toggleSidebar}
        >
          <div className="mv-logo">
            <img src={whiteLogo} className="logo"></img>
          </div>

          <button className="itemm">
            <span className="inner">
              <span className="label">Close</span>
            </span>
          </button>
        </div>

        <div className="hidden-bar-wrapper">
          <div className="side-menu">
            <ul className="menu2">
              <li>
                <a href="/login">Sign In </a>
              </li>
              <li onClick={() => jumpToReleventDiv2("skip-to-solution")}>
                Solutions
              </li>
              <li onClick={() => jumpToReleventDiv2("skip-to-features")}>
                Key Features
              </li>
              <li onClick={() => jumpToReleventDiv2("skip-to-furtherquestion")}>
                FAQs
              </li>
              <li
                className="nav-item"
                onClick={() => {
                  closeNavBar();
                  openBookADemoModal();
                }}
              >
                Book A Demo
              </li>
              <li
                className="nav-item"
                onClick={() => {
                  closeNavBar();
                  openContactUsModal();
                }}
              >
                Contact Us
              </li>
            </ul>
          </div>
        </div>

        {/* Uncomment if you want to add an image in the hidden bar */}
        {/* <div className="hidebar-img">
        <img src="images/hiddenbar-meeting.svg" alt="Hidden bar image" />
      </div> */}
      </section>
      {/* <!-- Hamburger Menu End --> */}

        <section className="section privacy-section">
          <div className="container">
            <h2 className="section-heading mt-5">
              Privacy Policy
              <br />
              <span>Our commitment to your data privacy.</span>
            </h2>

            <p className="mb-3 mt-5">
              The <strong>MinutesVault</strong> website does not automatically
              capture any specific personal information from you without your
              consent that allows us to identify you individually.
            </p>
            <p className="mb-3">
              If the <strong>MinutesVault</strong> website requests you to
              provide personal information, for registration or other
              activities, you will be informed of the particular purposes for
              which the information is gathered and adequate security measures
              will be taken to protect your personal information.
            </p>
            <p className="mb-3">
              We do not sell or share any personally identifiable information
              volunteered on the <strong>MinutesVault</strong> website to any
              third party (public or private). Any information provided to this
              portal will be protected from loss, misuse, unauthorized access or
              disclosure, alteration, or destruction.
            </p>
            <p className="mb-3">
              <strong>Site Visit Data:</strong> We gather certain information
              about the user, such as Internet protocol (IP) addresses, domain
              name, browser type, operating system, the date and time of the
              visit, and the pages visited. We make no attempt to link these
              addresses with the identity of individuals visiting our site
              unless an attempt to damage the site has been detected or such
              information is required for specific security or legal purposes.
            </p>
            <p>
              <strong>Cookie:</strong> This site does not use cookies.
            </p>
          </div>
        </section>

        {/* ✅ Keep existing Contact Us section */}
        {/* <section className="container">
              <h4 className="text-xl font-semibold mt-2">Contact Us</h4>
              <p>If you have questions or concerns, please contact us:</p>
              <div className=" space-y-1 text-sm">
                <div>
                  <strong>Email:</strong>{" "}
                  <a
                    href={`mailto:${contactEmail}`}
                    className="text-indigo-600 hover:underline"
                  >
                    {contactEmail}
                  </a>
                </div>
                <div>
                  <strong>Address:</strong> {companyAddress}
                </div>
              </div>
            </section>
      */}
        {
          <Modal
            className="book-a-demo-modal"
            show={showBookADemoModal}
            backdrop="static"
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={closeBookADemoModal}
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <div className="middle-text">👋🏻 Let’s get started!</div>
              <div className="middle-text mb-3">
                Excited to begin this journey with you.
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="contact-form mt-0">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-floating mb-3">
                            <div className="form-control-feedback-icon">
                              <i className="ph ph-user"></i>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Your Name"
                              name="name"
                              id="name"
                              maxLength={100}
                              autoComplete="off"
                              value={formData.name}
                              onChange={handleChange}
                              onBlur={() => nameValidationCheck(formData.name)}
                            />
                            <label htmlFor="name">
                              Enter Your Name <span>*</span>
                            </label>
                            {nameError && (
                              <p className="text-danger">{nameError}</p>
                            )}
                            {formErrors.name && (
                              <p className="text-danger">{formErrors.name}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-floating mb-3">
                            <div className="form-control-feedback-icon">
                              <i className="ph ph-phone"></i>
                            </div>
                            <input
                              type="number"
                              className="form-control only_number"
                              placeholder="Enter Mobile Number"
                              name="phoneNo"
                              id="phoneNo"
                              autoComplete="off"
                              value={formData.phoneNo}
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                              onBlur={() =>
                                phoneValidationCheck(formData.phoneNo)
                              }
                            />
                            <label htmlFor="phoneNo">
                              Enter Mobile Number <span>*</span>
                            </label>
                            {phoneError && (
                              <p className="text-danger">{phoneError}</p>
                            )}
                            {formErrors.phoneNo && (
                              <p className="text-danger">
                                {formErrors.phoneNo}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-12">
                          {/* Email Field with OTP Button */}
                          <div className="form-floating for-overflow-text">
                            <div className="form-control-feedback-icon">
                              <i className="ph ph-email"></i>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Work Email"
                              name="email"
                              id="email"
                              autoComplete="off"
                              value={formData.email}
                              readOnly={isOTPVerified}
                              onBlur={() =>
                                emailValidationCheck(formData.email)
                              }
                              onChange={handleChange}
                              maxLength="96"
                            />
                            <label htmlFor="email">
                              Enter Work Email <span>*</span>
                            </label>
                            {emailError && (
                              <p className="text-danger">{emailError}</p>
                            )}
                            {formErrors.email && (
                              <p className="text-danger">{formErrors.email}</p>
                            )}

                            {emailError == "" &&
                            isValidEmailEntered &&
                            !isOTPVerified ? (
                              <button
                                type="button"
                                className="btn btn-primary verify-email"
                                onClick={handleSendOtp}
                              >
                                {otpLoading ? "Sending..." : "Get OTP"}
                              </button>
                            ) : null}

                            {isOTPVerified ? (
                              <div className="image-tick">
                                <img
                                  src={Greencheck}
                                  className="green-check"
                                ></img>
                              </div>
                            ) : null}
                          </div>
                          {otpLoading === false ? (
                            <div className="">
                              {otpSuccessMessage && (
                                <p className="success-response">
                                  {otpSuccessMessage}
                                </p>
                              )}
                              {otpErrorMessage && (
                                <p className="error-response">
                                  {otpErrorMessage}
                                </p>
                              )}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-md-12">
                          {/* OTP Input and Verify Button (Shown after OTP is sent and until verified) */}
                          {otpSent === true && (
                            <div className="form-floating mt-3">
                              <div className="form-control-feedback-icon">
                                <i className="ph ph-otp"></i>
                              </div>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter OTP"
                                name="otp"
                                id="otp"
                                autoComplete="off"
                                onKeyDown={handleKeyDown}
                                value={otp}
                                onChange={handleOtpChange}
                              />
                              <label htmlFor="otp">
                                Enter OTP <span>*</span>
                              </label>

                              {otpError && (
                                <p className="text-danger">{otpError}</p>
                              )}

                              <div className="">
                                <button
                                  type="button"
                                  className="btn btn-primary verify-email"
                                  onClick={handleVerifyOtp}
                                  disabled={otpProcessloading}
                                >
                                  {otpProcessloading
                                    ? "Verifying..."
                                    : "Verify"}
                                </button>
                              </div>
                              {}
                            </div>
                          )}

                          {verifyOTPSuccessMessage != "" ||
                          verifyOTPErrorMessage != "" ? (
                            <div className="">
                              {verifyOTPSuccessMessage && (
                                <p className="success-response">
                                  {verifyOTPSuccessMessage}
                                </p>
                              )}
                              {verifyOTPErrorMessage && (
                                <p className="error-response">
                                  {verifyOTPErrorMessage}
                                </p>
                              )}
                            </div>
                          ) : null}
                        </div>

                        {/* OTP Verification Message */}
                        {/* Message Field */}
                        <div className="col-md-12">
                          <div className="form-floating mb-3 mt-3 for-overflow-text">
                            <div className="form-control-feedback-icon">
                              <i className="ph ph-message"></i>
                            </div>
                            <textarea
                              className="form-control"
                              placeholder="Message"
                              style={{ height: "120px" }}
                              name="message"
                              id="message"
                              maxLength={300}
                              autoComplete="off"
                              value={formData.message}
                              onChange={handleChange}
                            ></textarea>
                            <label htmlFor="message">Message</label>
                            {messageError && (
                              <p className="text-danger">{messageError}</p>
                            )}
                            {formErrors.message && (
                              <p className="text-danger">
                                {formErrors.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-12 mb-3 captcha-div">
                          <ReCAPTCHA
                            useRef={recaptchaRef}
                            sitekey={sitekey}
                            onChange={handleCaptchaChange}
                          />
                        </div>

                        <div className="book-demo-btn mt-2">
                          <button
                            type="submit"
                            className="book-btn"
                            disabled={loading}
                          >
                            {loading ? "Submitting..." : "Book A Demo"}
                          </button>
                        </div>
                        {/* General Form Submission Messages */}
                        {errorMessage && (
                          <p className="f-error-response">{errorMessage}</p>
                        )}
                        {successMessage && (
                          <p className="f-success-response">{successMessage}</p>
                        )}
                        {recaptchaError && (
                          <p className="f-error-response">{recaptchaError}</p>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        }

        <section className="section faq-page" id="skip-to-furtherquestion">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <h2
                  className="section-heading faq-header mb-3"
                  // data-aos="fade-up"
                >
                  Do you have any <span>further questions?</span>
                </h2>
                <p
                  className="explore-txt"
                  // data-aos="fade-up"
                  data-aos-delay="200"
                >
                  Explore our FAQs or reach out to the MinutesVault support team
                  for a personalized response!
                </p>
                <ul className="contact-details">
                  <li
                    className="has_fade_anim"
                    // data-aos="fade-up"
                  >
                    <span className="icons">
                      <img
                        src={phoneIcon}
                        className="phone-icon"
                        alt="Phone Icon"
                        width="50"
                        height="50"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </span>
                    <p>
                      <span className="list-heading has_char_anim">
                        Make a Call
                      </span>
                      <a href="tel:+918260003333" className="icon-hover">
                        +91-8260003333
                      </a>
                    </p>
                  </li>
                  <li
                    className="has_fade_anim"
                    //  data-aos="fade-up"
                  >
                    <span className="icons">
                      <img
                        src={mailIcon}
                        className="mail-icon"
                        alt="Mail Icon"
                        width="45"
                        height="45"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </span>
                    <p>
                      <span className="list-heading has_char_anim">
                        Write to Us
                      </span>
                      <a href="mailto:info@ntspl.co.in" className="icon-hover">
                        info@ntspl.co.in
                      </a>
                    </p>
                  </li>
                  <li
                    className="has_fade_anim"
                    //  data-aos="fade-up"
                  >
                    <span className="icons">
                      <img
                        src={locationIcon}
                        className="location-icon"
                        width="38"
                        height="38"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </span>
                    <p className="font-15 icon-hover">
                      <span className="list-heading has_char_anim">
                        Head Office
                      </span>
                      DLF Two Horizon Centre, 5th Floor, DLF Phase 5, Gurugram,
                      Haryana - 122002, Contact No- +91-8260003333
                    </p>
                    <p className="font-15 icon-hover mt-3">
                      <span className="list-heading has_char_anim">
                        Research & Development Center
                      </span>
                      DCB: #430, 4th Floor, DCB: #502 & 503, 5th Floor DLF Cyber
                      City, Chandaka Industrial Estate, Patia, Bhubaneswar,
                      Odisha 751024, Contact No- +91-9337705517, +91-8260003333
                      +91-7682835509
                    </p>
                  </li>
                </ul>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 position-relative">
                <div className="qa-bg">
                  <img src={faqBg} alt="FAQ Background" />
                </div>
                <div className="question-answers">
                  <div
                    className="accordion accordion-flush"
                    id="accordionFlushExample"
                  >
                    <div
                      className="accordion-item faq-border"
                      //  data-aos="fade-up"
                    >
                      <h2 className="accordion-header" id="flush-headingOne">
                        <button
                          className="accordion-button faq-heading collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseOne"
                          aria-expanded="false"
                          aria-controls="flush-collapseOne"
                        >
                          What is MinutesVault?
                        </button>
                      </h2>
                      <div
                        id="flush-collapseOne"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingOne"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body">
                          MinutesVault is a simple app designed to help you keep
                          track of everything that happens in meetings. It
                          allows you to create agendas, take notes during the
                          meeting, and assign tasks afterward. This way,
                          everyone knows what decisions were made and what they
                          need to do next.
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item"
                      //  data-aos="fade-up"
                    >
                      <h2 className="accordion-header" id="flush-headingTwo">
                        <button
                          className="accordion-button faq-heading collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseTwo"
                          aria-expanded="false"
                          aria-controls="flush-collapseTwo"
                        >
                          How does MinutesVault improve my meetings?
                        </button>
                      </h2>
                      <div
                        id="flush-collapseTwo"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingTwo"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body">
                          MinutesVault allows you to easily create meetings by
                          adding attendees, setting multiple agendas, choosing
                          the meeting mode, specifying the location, and
                          providing a meeting link. All your meetings are stored
                          in one place, giving you quick access to meeting
                          details and minutes.
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item"
                      //  data-aos="fade-up"
                    >
                      <h2 className="accordion-header" id="flush-headingThree">
                        <button
                          className="accordion-button collapsed faq-heading"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseThree"
                          aria-expanded="false"
                          aria-controls="flush-collapseThree"
                        >
                          Can I use MinutesVault on different devices?
                        </button>
                      </h2>
                      <div
                        id="flush-collapseThree"
                        className="accordion-collapse collapse show"
                        aria-labelledby="flush-headingThree"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body">
                          Absolutely! MinutesVault works on both computers and
                          mobile devices, so you can use it wherever you are.
                          Whether you're in the office, at home, or traveling,
                          you can take notes and manage your meetings from your
                          phone or tablet, making it convenient for everyone
                          involved.
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item"
                      //  data-aos="fade-up"
                    >
                      <h2 className="accordion-header" id="flush-headingFour">
                        <button
                          className="accordion-button collapsed faq-heading"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseFour"
                          aria-expanded="false"
                          aria-controls="flush-collapseFour"
                        >
                          What are the benefits of using MinutesVault?
                        </button>
                      </h2>
                      <div
                        id="flush-collapseFour"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingFour"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body">
                          MinutesVault allows you to easily create meetings by
                          adding attendees, setting multiple agendas, choosing
                          the meeting mode, specifying the location, and
                          providing a meeting link. All your meetings are stored
                          in one place, giving you quick access to meeting
                          details and minutes.
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item"
                      //  data-aos="fade-up"
                    >
                      <h2 className="accordion-header" id="flush-headingFour">
                        <button
                          className="accordion-button collapsed faq-heading"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseFive"
                          aria-expanded="false"
                          aria-controls="flush-collapseFive"
                        >
                          Is my data secure in the MinutesVault application?
                        </button>
                      </h2>
                      <div
                        id="flush-collapseFive"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingFive"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body">
                          MinutesVault prioritizes data security, employing
                          encryption and secure servers to protect your
                          information. Always check the app's privacy policy for
                          specific security measures. Access is strictly
                          controlled, allowing only authorized users within your
                          organization to view or edit your meeting notes.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- Further Question section end --> */}

        {/* <!-- Leading Brands start--> */}
        <section className="section leading-brand p-0">
          <div className="container">
            <h2
              className="section-heading has_word_anim mb-4"
              //  data-aos="fade-up"
            >
              We are trusted by leading brands
            </h2>

            {/* <section className="section leading-brand pb-0 p-0 mb-0 mt-2"> */}
            <div className="container">
              {/* Swiper for the first row of logos */}
              <section className="section leading-brand pb-0 p-0">
                <div className="container">
                  {/* Swiper for the first row of logos (left to right) */}
                  <Swiper
                    spaceBetween={0}
                    slidesPerView={5}
                    loop={true}
                    speed={4000}
                    autoplay={{
                      delay: 0,
                      disableOnInteraction: false,
                    }}
                    grabCursor={true}
                    direction={"horizontal"}
                    modules={[Navigation, Pagination, Autoplay]}
                  >
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={nalco}
                        alt="Nalco Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={vedanta}
                        alt="Vedanta Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={icarda}
                        alt="ICARDA Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={adityabirla}
                        alt="Aditya Birla Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={omc}
                        alt="OMC Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={trl}
                        alt="TRL Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={balco}
                        alt="Balco Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={bankOfBaroda}
                        alt="Bank of Baroda Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                  </Swiper>

                  {/* Swiper for the second row of logos (right to left) */}
                  <Swiper
                    spaceBetween={0}
                    slidesPerView={5}
                    loop={true}
                    speed={4000}
                    autoplay={{
                      delay: 0,
                      disableOnInteraction: false,
                      reverseDirection: true,
                    }}
                    grabCursor={true}
                    direction={"horizontal"}
                    modules={[Navigation, Pagination, Autoplay]}
                  >
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={hzl}
                        alt="HZL Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={imfa}
                        alt="Imfa Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={konkola}
                        alt="Konkola Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={lingarajPipe}
                        alt="Lingaraj Pipe Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={jindal}
                        alt="jindal Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={nmdc}
                        alt="NMDC Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={ocac}
                        alt="Ocac Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        className="image-bg"
                        src={facor}
                        alt="Vedanta Facor Logo"
                        width="230"
                        height="80"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </SwiperSlide>
                  </Swiper>
                </div>
              </section>
            </div>
            {/* </section> */}
          </div>
        </section>
        {/* <!-- Leading Brands end--> */}

        {/* <!-- Footer start--> */}
        <footer className="footer pb-0">
          <div className="container p-top">
            <div className="row">
              <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12">
                <h2
                  className="footer-heading has_word_anim"
                  //  data-aos="fade-up"
                >
                  With <span className="blue-text">MinutesVault</span> keep your
                  minutes organised and accessible <br /> from anywhere with
                  ease
                </h2>
                <div
                  className="book-demo-btn"
                  // data-aos="fade-up"
                >
                  <button className="book-btn" onClick={openContactUsModal}>
                    Enquiry Now
                    <span className="arrow-spacing">
                      <img src={arrow} alt="Arrow" />
                    </span>
                    <div className="button__shadow"></div>
                  </button>
                </div>
              </div>
              <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                <img
                  src={meetingbgall}
                  className="footer-meeting-bg-all"
                  alt="Meeting Background"
                  width="694"
                  height="516"
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </div>
            </div>

            <div className="footer-bottom">
              <div className="left-bottom">
                <div className="social-boxes">
                  <a
                    href="https://www.facebook.com/people/MinutesVault/61567147532629/"
                    className="s-box"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={fbIcon}
                      alt="Facebook"
                      width="20"
                      height="20"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </a>
                  <a
                    href="https://x.com/MinutesVault"
                    className="s-box"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={twiter}
                      alt="Twitter"
                      width="20"
                      height="20"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/minutesvault/"
                    className="s-box"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={linkedIn}
                      alt="LinkedIn"
                      width="20"
                      height="20"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/@MinutesVault"
                    className="s-box"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={youtube}
                      alt="YouTube"
                      width="20"
                      height="20"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/minutesvault/"
                    className="s-box"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={instagram}
                      alt="Instagram"
                      width="20"
                      height="20"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </a>
                </div>
                {/* <p>Powered by MinutesVault</p> */}
              </div>
              <div className="right-bottom">
                {/* <ul>
                <li>
                  <a>Terms & Condition</a>
                </li>
                <li>
                  <a>Privacy Policy</a>
                </li>
              </ul> */}
                <p>Powered by NTSPL</p>
              </div>
            </div>
          </div>

          <div className="left-footer-bg"></div>
          <div className="right-footer-bg"></div>
          <img
            src={footerWhite}
            className="footer-white"
            alt="Footer Background"
          />
        </footer>
      </div>

    </>
  );
};

export default PrivacyPolicy;
